// extracted by mini-css-extract-plugin
module.exports = {"root":"StepTitle_root__1EPOw"};